import { type SelectionsMachine } from '../../machine/selection-machine';
import { type SelectionInput } from '../types';

export type StructuralChange = {
  entries: { prev: string[]; next: string[] };
  fields: { prev: string[]; next: string[] };
};

export type StructuralChangeCallback = (
  onChange: (change: StructuralChange) => void
) => VoidFunction;

export function createYjsChangesInput(
  machine: SelectionsMachine,
  subscribe: StructuralChangeCallback
): SelectionInput {
  let unsubscribe: VoidFunction | null;

  return {
    setup() {
      unsubscribe = subscribe((change) => {
        machine.dispatch({
          type: 'reconcileSelections',
          source: 'api',
          ...change
        });
      });
    },

    dispose() {
      unsubscribe?.();
    }
  };
}
